/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  createReducerName,
  registryCombineReducer
} from 'mt-react-common/modules/messenger/reducers/dynamic/roomMessages/combineRegistry';

import {
  dataRequest as getRoomSendRequest,
  selectItemById,
  selectRequestsStateById
} from 'mt-react-common/common/reducers/objectCollection/reducer';

import {
  initState as messagesInitState,
  sendRequest,
  selectItemsIds as messagesSelectItemsIds,
  selectItemById as messagesSelectItemByIdIn,
  selectRequestState as messagesSelectRequestState,
  selectPagination as messagesSelectPagination,
  changeQueryParams as messagesChangeQueryParams
} from 'mt-react-common/common/reducers/list/reducer';

import {
  sendRequest as sendMessageForm,
  selectRequestState as messageFormSelectRequestState,
  changeFieldMessage,
  selectFieldMessage
} from 'mt-react-common/modules/messenger/reducers/dynamic/roomMessages/sendMessagesForm/reducer';

import {
  selectUserId,
  selectAvatarPath
} from 'mt-react-common/modules/users/common/reducers/states/authAccount';

import MessengerService from 'mt-react-common/modules/messenger/services/MessengerService';

const userRoomsCollectionRN = 'messengerModule.collections.userRoomsCollection';
const messengerMyRoomsListReduceName =
  'messengerModule.lists.messengerMyRoomsList';

const combineName = roomUuid => createReducerName(`room-${roomUuid}`);
const roomMessagesListRN = roomUuid => `${combineName(roomUuid)}.list`;
const roomMessagesSendFormRN = roomUuid =>
  `${combineName(roomUuid)}.sendMessageForm`;

export default function createContainer(ChildContainer) {
  class UserRoomViewContainer extends Component {
    constructor(props) {
      super(props);
      registryCombineReducer(combineName(props.match.params.roomUuid));
      this.props.messagesInitState();
      this.props.getRoomSendRequest();
      this.props.getMessagesSendRequest();
    }

    showMoreMessages = () => {
      if (
        this.props.messagesPagination.currentPage !==
          this.props.messagesPagination.pageCount &&
        this.props.messagesPagination.currentPage !== 0
      ) {
        this.props.messagesChangeQueryParams({
          page: this.props.messagesPagination.currentPage + 1
        });
        this.props.getMessagesSendRequest();
      }
    };

    // Выйти из группы
    leaveFromGroupRoom = () => {
      MessengerService.leaveGroupRoom(
        this.props.reduxState,
        this.props.match.params.roomUuid
      ).then(result => {
        if (result) {
          if (result.response.status === 422) {
            console.log(result.response);
          } else if (result.response.status === 200) {
            console.log(result.response);
          }
        }
        this.setState({ loading: false });
      });
    };

    render() {
      return (
        <ChildContainer
          {...this.props}
          leaveFromGroupRoom={this.leaveFromGroupRoom}
          showMoreMessages={this.showMoreMessages}
        />
      );
    }
  }

  UserRoomViewContainer.defaultProps = {
    fieldMessage: null,
    messagesRequestState: null,
    messagesPagination: null,
    messageFormRequestState: null,
    messagesItemsIds: []
  };

  UserRoomViewContainer.propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        roomUuid: PropTypes.string
      })
    }).isRequired,

    auntUserId: PropTypes.number.isRequired,
    auntUserAvatarPath: PropTypes.string.isRequired,

    fieldMessage: PropTypes.shape({
      field: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      errors: PropTypes.array.isRequired
    }),
    // CONNECT DISPATCH
    reduxState: PropTypes.shape({}).isRequired,
    messagesInitState: PropTypes.func.isRequired,
    getMessagesSendRequest: PropTypes.func.isRequired,
    messagesRequestState: PropTypes.shape({
      inProgress: PropTypes.bool.isRequired
    }),
    messagesChangeQueryParams: PropTypes.func.isRequired,
    messagesPagination: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      pageCount: PropTypes.number.isRequired,
      perPage: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    }),

    messengerMyRoomsRefresh: PropTypes.func.isRequired,
    getRoomSendRequest: PropTypes.func.isRequired,

    changeFieldMessage: PropTypes.func.isRequired,
    sendMessageForm: PropTypes.func.isRequired,
    messageFormRequestState: PropTypes.shape({
      hasInProgress: PropTypes.bool.isRequired
    }),

    messagesItemsIds: PropTypes.arrayOf(PropTypes.number),
    getMessageById: PropTypes.func.isRequired
  };

  const mapStateToProps = (state, props) => ({
    auntUserId: selectUserId(state),
    auntUserAvatarPath: selectAvatarPath(state),

    roomRequestState: selectRequestsStateById(
      state,
      userRoomsCollectionRN,
      props.match.params.roomUuid
    ),
    room: selectItemById(
      state,
      userRoomsCollectionRN,
      props.match.params.roomUuid
    ),
    // Messages
    messagesRequestState: messagesSelectRequestState(
      state,
      roomMessagesListRN(props.match.params.roomUuid)
    ),
    messagesItemsIds: messagesSelectItemsIds(
      state,
      roomMessagesListRN(props.match.params.roomUuid)
    ),
    getMessageById: id =>
      messagesSelectItemByIdIn(
        state,
        roomMessagesListRN(props.match.params.roomUuid),
        id
      ),
    messagesPagination: messagesSelectPagination(
      state,
      roomMessagesListRN(props.match.params.roomUuid)
    ),

    // Message form
    fieldMessage: selectFieldMessage(
      state,
      roomMessagesSendFormRN(props.match.params.roomUuid)
    ),
    messageFormRequestState: messageFormSelectRequestState(
      state,
      roomMessagesSendFormRN(props.match.params.roomUuid)
    ),
    reduxState: state
  });

  const mapDispatchToProps = (dispatch, props) => ({
    messengerMyRoomsRefresh: () =>
      dispatch(sendRequest(messengerMyRoomsListReduceName)),
    getRoomSendRequest: () =>
      dispatch(
        getRoomSendRequest(userRoomsCollectionRN, props.match.params.roomUuid)
      ),
    // Messages
    messagesInitState: () =>
      dispatch(
        messagesInitState(roomMessagesListRN(props.match.params.roomUuid), true)
      ),
    getMessagesSendRequest: () =>
      dispatch(
        sendRequest(
          roomMessagesListRN(props.match.params.roomUuid),
          props.match.params.roomUuid
        )
      ),
    messagesChangeQueryParams: params =>
      dispatch(
        messagesChangeQueryParams(
          roomMessagesListRN(props.match.params.roomUuid),
          params
        )
      ),
    // Message form
    changeFieldMessage: value =>
      dispatch(
        changeFieldMessage(
          roomMessagesSendFormRN(props.match.params.roomUuid),
          value
        )
      ),
    sendMessageForm: () =>
      dispatch(
        sendMessageForm(
          roomMessagesSendFormRN(props.match.params.roomUuid),
          props.match.params.roomUuid
        )
      )
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserRoomViewContainer);
}



// WEBPACK FOOTER //
// ./src/components/Messenger/containers/UserRoomViewContainer/UserRoomViewContainer.js